import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Validate username format (client-safe)
 * Only allows alphanumeric characters (letters and numbers, no spaces or special characters)
 */
export function validateUsername(username: string): { valid: boolean; error?: string } {
  if (username.length < 3) {
    return { valid: false, error: "Username must be at least 3 characters long" }
  }
  if (username.length > 30) {
    return { valid: false, error: "Username must be at most 30 characters long" }
  }
  // Only allow alphanumeric characters (letters and numbers, no spaces, no special characters)
  if (!/^[a-zA-Z0-9]+$/.test(username)) {
    return { valid: false, error: "Username can only contain letters and numbers (no spaces or special characters)" }
  }
  return { valid: true }
}
